export default __webpack_public_path__ + "static/media/globe_outline_20.254ed4fc.svg";